import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import $http from './request/http'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// import $socket from './utils/socket';
import Vant from 'vant';
import 'vant/lib/index.css';
import './utils/flexible';
import voicePromptFun from './utils/voice';
// 引入echarts
import * as echarts from 'echarts';
console.log(voicePromptFun)
// Vue.use(ElementUI);
Vue.prototype.$echarts = echarts;
Vue.prototype.voicePrompt = voicePromptFun  //语音提醒
Vue.prototype.$http = $http;
Vue.config.productionTip = false
Vue.use(Vant)
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('token');
  document.title = to.meta.title;
  // const role = localStorage.getItem('ms_username');
  console.log('role', token, from)
  next();

})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
